<div
  class="modal__overlay"
  *ngIf="isOpen"
  (click)="settings?.allowClickOutsideToClose && onClose()"
></div>
<div class="modal" *ngIf="isOpen">
  <div
    class="modal__container"
    [ngClass]="modalPositionClass"
    [ngStyle]="modalStyles"
  >
    <div class="modal__header" *ngIf="settings?.hasHeader">
      <div #header>
        <ng-content select="[header]"></ng-content>
      </div>
      <button
        type="button"
        class="modal__close-button"
        *ngIf="settings?.showCloseButton"
        (click)="onClose()"
        aria-label="Fechar modal"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal__body" cdkScrollable>
      <div class="modal__content">
        <ng-content select="[body]"></ng-content>
      </div>
    </div>

    <div class="modal__footer" *ngIf="settings?.hasFooter">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
